document.addEventListener("alpine:init", () => {
  Alpine.data("bfBanner", () => ({
    loading: false,
    email: "",
    errMsg: "",
    checked: false,
    isSuccess: false,

    async submitResult(event) {
      if (!this.checked) {
        this.errMsg = "Please tick agreement boxes to proceed.";
        return;
      }
      const isEmailValid = validateEmail(this.email);
      if (!isEmailValid) {
        this.errMsg = "Email: invalid format!";
        return;
      }
      // If no error, remove error message
      this.errMsg = "";

      // Check if the click comes from the element with x-ref="submitButton"
      if (event.target === this.$refs.submitButton) {

        console.log('Submit button clicked');

        this.loading = true;
        this.errMsg = '';
        this.isSuccess = false;

         // Trigger the form submission
         const form = document.getElementById('email-subscribe-form');
         if(form) form.submit();

      } else {

        const fieldsArray = createFieldsArray(bfbannerSettingJsons);
        // getContactListId function in subscription-form-common.js
        const contactListId = getContactListId(bfbannerSettingJsons);

        // Extract theme global variables from theme.liquid
        const { apiUrl, acceptedLanguage, apiKey, xAppid } =
          theme.emailSubscription;

        const apiBody = {
          email: this.email,
          contactListId,
          fields: fieldsArray,
        };
        this.loading = true;
        try {
          const response = await fetch(
            // Header global settings are defined in star-email-subscription-form.liquid
            // Except traceId is defined in subscription-form-common.js
            apiUrl,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                apiKey: apiKey,
                traceId: traceId,
                "X-appid": xAppid,
                "Accepted-Language": acceptedLanguage,
              },
              body: JSON.stringify(apiBody),
            }
          );

          const data = await response.json();

          if (data.message === "Success") {
            this.isSuccess = true;
          }
        } catch (error) {
          this.errMsg =
            "Oops... Something went wrong, please refresh and try again.";
        } finally {
          this.loading = false;
        }
      }

    },
  }));
});
